import { LocalParticipant } from "twilio-video";
import { removeLocalParticipantTracks } from "./removeLocalParticipantTracks";

export const unpublishAudioTrack = (localParticipant: LocalParticipant) => {
  const tracks = Array.from(localParticipant.audioTracks.values()).map(
    (tr) => tr.track,
  );
  removeLocalParticipantTracks(localParticipant, tracks);
};
